import { FIELD_VALUE_SOURCE, IMPORT_DESCRIPTOR_TYPE } from '../../../../../../constants/generalConstants';
import { FieldValueType, ImportDescriptorDataTypeType } from '../../../../../../types';
import createColorGradient from '../../../../../../utils/colorGradients';

const getColorFromConfidence = createColorGradient();

type GetReportCellStylingReturnType = {
    styles: Record<string, string>;
    classes: string;
};

export function getReportCellStyling(
    fieldValue: FieldValueType,
    editing: boolean,
    isActive: boolean
): GetReportCellStylingReturnType {
    const styles: Record<string, string> = {};
    styles['--confidence-color'] = getColorFromConfidence(fieldValue.rawValueConfidence);

    let classes = '';
    const source = fieldValue.source;
    if (source === FIELD_VALUE_SOURCE.CALCULATION) {
        classes = `${classes} value--calculated`;
    } else if (source === FIELD_VALUE_SOURCE.MASTER_TABLE) {
        classes = `${classes} value--master-table`;
    }

    if (styles['--confidence-color']) {
        classes = `${classes} confidence`;
    }

    if (editing) {
        classes = `${classes} cell--editing`;
    }

    if (isActive && editing) {
        classes = `${classes} cell--active`;
    }

    return { styles, classes };
}

// TODO: this should live in the descriptor type util after conforming the type values and converting them to objects
export function getIsDescriptorNumericType(descriptorType: ImportDescriptorDataTypeType) {
    return descriptorType === IMPORT_DESCRIPTOR_TYPE.NUMBER || descriptorType === IMPORT_DESCRIPTOR_TYPE.PERCENT;
}
